<template>
	<div class="login-container">
		<el-row>
			<el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
				<div style="color: transparent">占位符</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
				<el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login-form" label-position="left">
					<div class="title">{{ systemInfo.title }}</div>
					<el-form-item prop="username">
						<span class="svg-container svg-container-admin">
							<vab-icon :icon="['fas', 'user']" />
						</span>
						<el-input v-model.trim="loginForm.username" :placeholder="langTxt('账号')" tabindex="1" type="text" @input="change($event)" />
					</el-form-item>
					<el-form-item prop="password">
						<span class="svg-container">
							<vab-icon :icon="['fas', 'lock']" />
						</span>
						<el-input :key="passwordType" ref="password" v-model.trim="loginForm.password" :type="passwordType" tabindex="2" :placeholder="langTxt('密码')" @keyup.enter.native="handleLoginForm" @input="change($event)" />
						<span v-if="passwordType === 'password'" class="show-password" @click="handlePassword">
							<vab-icon :icon="['fas', 'eye-slash']"></vab-icon>
						</span>
						<span v-else class="show-password" @click="handlePassword">
							<vab-icon :icon="['fas', 'eye']"></vab-icon>
						</span>
					</el-form-item>
					<!-- // 验证吗 -->
					<el-form-item prop="code">
						<el-col :span="11">
							<span class="svg-container svg-container-admin">
								<vab-icon :icon="['fas', 'lock']" />
							</span>
							<el-input v-model.trim="loginForm.code" :placeholder="langTxt('验证码')" tabindex="3" type="text" @input="change($event)" />
						</el-col>
						<el-col class="line" :span="2">&nbsp;</el-col>
						<el-col :span="11">
							<img class="user-avatar" :src="verificationImg" alt="" width="100%" height="58px" />
						</el-col>
					</el-form-item>
					<!-- // 看不清 -->
					<div style="float:right">
						<el-link @click="changeCode" type="info">{{ langTxt('看不清? 换一张') }}</el-link>
					</div>
					<el-button :loading="loading" class="login-btn" type="primary" @click="handleLoginForm">
						{{ langTxt('登录') }}
					</el-button>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	export default {
		name: 'Login',
		data() {
			return {
				// 登录表单数据对象
				loginForm: {
					username: '',
					password: '',
					code: '',
					captcha_id: ''
				},
				// 登录表单的校验对象
				loginFormRules: {
					username: [
						{
							required: true,
							message: this.langTxt('请输入') + this.langTxt('账号'),
							trigger: 'blur'
						}
					],
					password: [
						{
							required: true,
							message: this.langTxt('请输入') + this.langTxt('密码'),
							trigger: 'blur'
						}
					],
					code: [
						{
							required: true,
							message: this.langTxt('请输入') + this.langTxt('验证吗'),
							trigger: 'blur'
						}
					]
				},
				passwordType: 'password',
				loading: false,
				verificationImg: '',
				systemInfo: {
					title: '短链管理'
				}
			};
		},

		mounted() {
			window.addEventListener('keypress', this.onEnter);
		},

		beforeDestroy() {
			window.removeEventListener('keypress', this.onEnter);
		},
		// 获取数据
		created() {
			this.getCaptcha();
			this.getSysConfigInfo();
		},
		methods: {
			// 获取验证吗 -1
			getCaptcha() {
				this.request.get('/captcha-id').then((ret) => {
					this.loginForm.captcha_id = ret.code;
					if (ret.code) {
						this.getCode(ret.code);
					}
				});
			},
			// 获取验证吗 -2
			getCode(code) {
				this.request
					.get('/captcha-image', {
						params: {
							code: code
						},
						responseType: 'blob'
					})
					.then((ret) => {
						this.verificationImg = window.URL.createObjectURL(ret);
					});
			},
			// 重新获取验证码
			changeCode() {
				this.getCaptcha();
			},
			// 密码
			handlePassword() {
				this.passwordType === 'password' ? (this.passwordType = '') : (this.passwordType = 'password');
				this.$nextTick(() => {
					this.$refs.password.focus();
				});
			},
			// 多层嵌套无法输入解决方法
			change() {
				this.$forceUpdate();
			},
			// 登录方法
			handleLoginForm() {
				this.$refs.loginFormRef.validate((valid) => {
					if (valid) {
						// 登入接口接入
						this.loading = true;
						this.request.post('/login', this.loginForm).then((data) => {
							this.$store.commit('setMenuList', []); // 清空侧边栏菜单
							this.$store.commit('updateLock', null); // 清除锁屏
							this.$store.commit('setToken', data.token); // token
							this.$store.commit('setUser', data.user); // user
							this.$baseNotify('Login Success', 'welcome', 'success');
							this.$router.push('/');
						});
					} else {
						this.$baseMessage(this.langTxt('请输入') + this.langTxt('密码') + '/' + this.langTxt('账号'), 'error');
					}
					this.loading = false;
				});
			},

			getSysConfigInfo() {
				this.request.get('/common-config').then((ret) => {
					this.systemInfo.title = ret.title;
					this.$store.commit('setCommonConfig', ret); // user
				});
			},

			// 监听回车事件
			onEnter(e) {
				if (e.key === 'Enter') {
					this.handleLoginForm();
				}
			}
		}
	};
</script>
<style lang="scss" scoped>
	.login-container {
		height: 100vh;
		background: url('~@/assets/images/background.jpg') center center fixed no-repeat;
		background-size: cover;

		.title {
			font-size: 34px;
			font-weight: 500;
			color: rgba(14, 18, 26, 1);
		}

		.title-tips {
			margin-top: 29px;
			font-size: 26px;
			font-weight: 400;
			color: rgba(14, 18, 26, 1);
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.login-btn {
			display: inherit;
			width: 220px;
			height: 60px;
			margin-top: 5px;
			border: 0;

			&:hover {
				opacity: 0.9;
			}
		}

		.login-form {
			position: relative;
			max-width: 100%;
			margin: calc((100vh - 525px) / 2) 10% 10%;
			overflow: hidden;

			.forget-password {
				width: 100%;
				margin-top: 40px;
				text-align: left;

				.forget-pass {
					width: 129px;
					height: 19px;
					font-size: 20px;
					font-weight: 400;
					color: rgba(92, 102, 240, 1);
				}
			}
		}

		.tips {
			margin-bottom: 10px;
			font-size: $base-font-size-default;
			color: $base-color-white;

			span {
				&:first-of-type {
					margin-right: 16px;
				}
			}
		}

		.title-container {
			position: relative;

			.title {
				margin: 0 auto 40px auto;
				font-size: 34px;
				font-weight: bold;
				color: $base-color-blue;
				text-align: center;
			}
		}

		.svg-container {
			position: absolute;
			top: 14px;
			left: 15px;
			z-index: $base-z-index;
			font-size: 16px;
			color: #d7dee3;
			cursor: pointer;
			user-select: none;
		}

		.show-password {
			position: absolute;
			top: 14px;
			right: 40px;
			font-size: 16px;
			color: #d7dee3;
			cursor: pointer;
			user-select: none;
		}

		::v-deep {
			.el-form-item {
				padding-right: 0;
				margin: 20px 0;
				color: #454545;
				background: transparent;
				border: 1px solid transparent;
				border-radius: 2px;

				&__content {
					min-height: $base-input-height;
					line-height: $base-input-height;
				}

				&__error {
					position: absolute;
					top: 100%;
					left: 18px;
					font-size: $base-font-size-small;
					line-height: 18px;
					color: $base-color-red;
				}
			}

			.el-input {
				box-sizing: border-box;

				input {
					height: 58px;
					padding-left: 45px;
					font-size: $base-font-size-default;
					line-height: 58px;
					color: $base-font-color;
					background: #f6f4fc;
					border: 0;
					caret-color: $base-font-color;
				}
			}
		}
	}
</style>
